

















import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import { Injectable, Container } from 'ca-middleware';
import customPanel from './CustomPanel.vue';

import Belong from './component/belong.vue';
import EnterpriseType from './component/enterpriseType.vue';
import WorkType from './component/workType.vue';
import MoneyType from './component/moneyType.vue';
import Capital from './component/capital.vue';
@Component({
    name: 'CustomComponent',
    components : {
      customPanel,
      Belong,
      EnterpriseType,
      WorkType,
      MoneyType,
      Capital,
    },
})
export default class CustomComponent extends Vue {
  @Prop() private showCustomPanel: any;
  @Prop() private closeCustomComponent: any;
  private rightComponent0: string = '';
  private rightComponent1: string = '';
  private rightComponent2: string = '';
  private closeCustomPanel() {
    this.closeCustomComponent();
  }
  private complate(data: any) {
    const self: any = this;
    self.leftComponent0 = '';
    self.leftComponent1 = '';
    self.leftComponent2 = '';
    self.rightComponent0 = '';
    self.rightComponent1 = '';
    self.rightComponent2 = '';
    // 组件
    const typeMap: any = {
        WorkType: 'WorkType',
        MoneyType: 'MoneyType',
        Capital: 'Capital',
        EnterpriseType: 'EnterpriseType',
        Belong: 'Belong',
    };
    // for (const i in data.left) {
    //   if (data.left.hasOwnProperty(i)) {
    //     const leftcomponentName: any = typeMap[data.left[i]];
    //     if (leftcomponentName) {
    //       self['leftComponent' + i] = leftcomponentName;
    //     } else {
    //       throw(new Error('左侧不支持的定制！'));
    //     }
    //   }
    // }
    for (const i in data.right) {
      if (data.right.hasOwnProperty(i)) {
        const rightcomponentName: any = typeMap[data.right[i]];
        if (rightcomponentName) {
            self['rightComponent' + i] = rightcomponentName;
        } else {
            throw(new Error('右侧不支持的定制！'));
        }
      }
    }
    // this.showCustomPanel = false;
    // const sortableLeft = new Sortable(document.getElementById('customMadeLeft'), {
    //   ghostClass: 'blue-background-class',
    //   animation: 150,
    // });
    // const sortableRight = new Sortable(document.getElementById('customMadeRight'), {
    //   ghostClass: 'blue-background-class',
    //   animation: 150,
    // });
  }
}
